import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { program } from '__mocks__/mockData/program-data';

const ProgramsApi = [rest.get(`${API_ROOT}programs`, (req, res, ctx) => res(ctx.json(program)))];
export default ProgramsApi;
